meedy.directive('meedyButtonBar', ['$parse',
    function($parse) {
        var definition = {
            restrict: 'E',
            scope: {
                value: '=',
                buttons: '=',
                toggleEnabled: '@',
                required: '@?',
                isRadio: '='
            },
            templateUrl: 'meedy/application/directive/meedyButtonBar/template/meedy-button-bar.html',
            link: function($scope, element, attr) {
                $scope.required = $scope.required === true;

                $scope._toggleEnabled = _.isUndefined($scope.toggleEnabled) ? true : $scope.$eval($scope.toggleEnabled);

                $scope.toggleButton = function(button) {
                    if (!_.isUndefined($scope.value) && ($scope.value == button.value) && $scope._toggleEnabled) {
                        if($scope.isRadio) {
                            $scope.value = button.value;
                        } else {
                            $scope.value = undefined;
                        }
                    }
                    else {
                        $scope.value = button.value;
                    }
                };

                if (!$scope._toggleEnabled) {
                    var foundButton = _.find($scope.buttons, function (button) {
                        return ($scope.value == button.value);
                    });

                    if (!foundButton) {
                        $scope.value = $scope.buttons[0].value;
                    }
                }
            }
        };

        return definition;
    }
]);